import type { LntTransferItem } from './types'

export const filterOption = (value: string, item: LntTransferItem): boolean => {
  const lowerCasedValue = value.toLowerCase()
  const words = lowerCasedValue.split(' ')
  return words.some(word => item.title?.toLowerCase().includes(word)) ?? false
}

export const render = (item: LntTransferItem): string => item.title ?? ''
